import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { IGoals } from '@interfaces/goals';
import { ErrorAndLoadingService } from '../error-loading/error-loading.service';
import { FirebaseService } from '../firebase/firebase.service';

@Injectable({
  providedIn: 'root',
})
export class GoalService {

  goalsSub: any;
  private goalsSource = new BehaviorSubject<IGoals[]>(null);
  currentGoalsSource = this.goalsSource.asObservable();

  constructor(private firebaseService: FirebaseService, private errorService: ErrorAndLoadingService) {
  }

  getGoalsObs(uid: string) {
    this.goalsSub = this.firebaseService.getSnapshotObs('goals', 'userId', uid, this.goalsSource);
  }

  async createGoal(goal: IGoals) {
    try {
      const collection = this.firebaseService.getCollection('goals');
      return await this.firebaseService.addDocumentWithID(goal, collection, goal.portfolioId);
    } catch (err) {
      this.errorService.presentToastWithDuration(2000, 'top', 'Error al crear la meta, inténtalo nuevamente', false);
      throw err;
    }
  }

  async getUserGoals(uid: string): Promise<IGoals[]> {
    const collection = this.firebaseService.getCollection('goals');
    const goals = await this.firebaseService.getDocumentsWithSingleQuery(collection, 'userId', '==', uid);
    const userGoals: IGoals[] = [];
    let completeGoal = {};
    for (let indexGoals = 0; indexGoals < goals.docs.length; indexGoals++) {
      completeGoal = goals.docs[indexGoals].data();
      completeGoal['id'] = goals.docs[indexGoals].id;
      userGoals.push({...completeGoal} as IGoals);
    }
    return userGoals;
  }

  async getGoal(id: string) {
    try {
      if (this.goalsSource.value) {
        return this.goalsSource.value.find(g => g.id === id);
      }
      const collection = this.firebaseService.getCollection('goals');
      const goalSnapshot = await this.firebaseService.getDocumentObject(id, collection);
      const goal = goalSnapshot.data();
      goal['id'] = goalSnapshot.id;
      return goal as IGoals;
    } catch (err) {
      this.errorService.presentToastWithDuration(2000, 'top', 'Error al obtener la meta, inténtalo nuevamente', false);
      throw err;
    }
  }

  async getGoalByPortfolio(id: string, uid: string) {
    const userGoals: IGoals[] = [];
    if (this.goalsSource.value) {
      const goal = this.goalsSource.value.find(g => g.portfolioId === id);
      if (goal) {
        userGoals.push(goal);
      }
      return userGoals;
    }
    const collection = this.firebaseService.getCollection('goals');
    const goals = await this.firebaseService.getDocumentsWithSingleQuery(collection, 'portfolioId', '==', id, uid, true);
    let completeGoal = {};
    for (let indexGoals = 0; indexGoals < goals.docs.length; indexGoals++) {
      completeGoal = goals.docs[indexGoals].data();
      completeGoal['id'] = goals.docs[indexGoals].id;
      userGoals.push(completeGoal as IGoals);
    }
    return userGoals;
  }

  async updateGoal(goal: IGoals) {
    try {
      const goalObject = {...goal};
      const id = goal.id;
      delete goalObject.id;
      const collection = this.firebaseService.getCollection('goals');
      const newGoal = await this.firebaseService.updateDocumentWithMerge(goalObject, collection, id);
      this.errorService.presentToastWithDuration(2000, 'top', 'La meta fue actualizada con éxito', false);
      return newGoal;
    } catch (err) {
      this.errorService.presentToastWithDuration(2000, 'top', 'Error al actualizar la meta, inténtalo nuevamente', false);
      throw err;
    }
  }

  deleteGoal(goalId: string): Promise<any> {
    return this.firebaseService.deleteDocument(this.firebaseService.getCollection('goals'), goalId);
  }

}
